import React, { useEffect } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import { API_URL } from "../constants";

const DownloadApp: React.FC = () => {
  useEffect(() => {
    const handleRedirect = () => {
      // Check for QR parameter and log the scan
      const urlParams = new URLSearchParams(window.location.search);
      const qrId = urlParams.get('qr');

      if (qrId) {
        fetch(`${API_URL}/qr/scan`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ qrId }),
        })
          .then(() => console.log('QR Scan Recorded'))
          .catch((error) => console.error('QR Scan Error:', error));
      }

      const iosAppStoreLink = "https://apps.apple.com/app/apple-store/id6560116116?pt=127150541&ct=main&mt=8";
      const androidPlayStoreLink = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.citymoshi.app";

      if (isIOS) {
        window.location.href = iosAppStoreLink;
      } else if (isAndroid) {
        window.location.href = androidPlayStoreLink;
      } else {
        window.location.href = "https://citymoshi.com";
      }

      setTimeout(() => {
        window.location.href = "https://citymoshi.com";
      }, 1000);
    };

    handleRedirect();
  }, []);

  return (
    <div className="w-full flex items-center justify-center min-h-screen bg-white">
      <img
        src="/images/logo/main-logo.png"
        alt="Citymoshi Logo"
        className="w-12 h-12 object-contain"
      />
    </div>
  );
};

export default DownloadApp;
